module.exports = __webpack_public_path__ + "static/media/logo.d6132cc4.svg";